import { safeSessionStorage } from 'safe-storage';
import MicroModal from 'micromodal';

function setVisitorInformation(data) {
  safeSessionStorage.setItem("visitorInformation", JSON.stringify({
    countryCode: data.countryCode,
  }));
}

function getVisitorInformation() {
  let vi = safeSessionStorage.getItem("visitorInformation");
  if (!vi) {
    return jQuery.getJSON('/visitor-information').then((data) => {
      safeSessionStorage.setItem("visitorInformation", JSON.stringify(data));
      return data;
    })
  }
  return jQuery.Deferred().resolve(JSON.parse(vi)).promise();
}

const m = location.search.match(/(?:\?|&)__countryCode=(\w+)/);
if (m) {
  setVisitorInformation({ countryCode: m[1] });
}

getVisitorInformation().then((vi) => {
  if (vi.countryCode === 'JP' || navigator.language === 'ja') {
    document.body.classList.add('is-domestic');
    return;
  }

  document.body.classList.add('is-foreign');

  if (document.cookie.indexOf('modal-for-foreign-shown=1') === -1 || location.search.indexOf('__showModalForForeign') !== -1) {
    document.cookie = 'modal-for-foreign-shown=1; path=/; max-age=604800';
    document.addEventListener("DOMContentLoaded", () => {
      const modal = document.createElement("div");
      modal.id = "modal-for-foreign";
      modal.className = "modal micromodal-slide";
      modal.innerHTML = `
<div class="modal__overlay" tabindex="-1" data-micromodal-close>
<button class="modal__close" aria-label="Close modal" data-micromodal-close></button>
<div class="modal__container" role="dialog" aria-modal="true">
  <div class="modal__header">
    <button class="modal__close" aria-label="Close modal" data-micromodal-close></button>
  </div>
  <a href="/d/internationalshipping/">
  <main class="modal__content">
    <img src="https://hoshubuhin.com/a/img/banner/kv-intnl-banner.jpg" alt="We ship internationally" />
  </main>
  </a>
</div>
</div>
`;
      document.body.appendChild(modal);
      MicroModal.init();
      MicroModal.show('modal-for-foreign');
    });
  }
});
